import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

function System() {
  return (
    <Template>
      <BreadCrumb pageName="Free Session" />
    </Template>
  );
}

export default System;
